import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Typography, makeStyles } from "@material-ui/core";
import { useIntl } from "react-intl";
import { messages } from "./messages";
import { useCallback } from "react";
import { useResource } from "rest-hooks";
import { BuyoutSettingsEndpoint } from "./endpoints/BuyoutSettings";
import { BuyoutCalculationResult } from "./components/BuyoutCalculationResult";
import { BuyoutForm } from "./components/BuyoutForm";
import { useBuyoutGetContract } from "./hooks/useBuyoutGetContract";
import { useBuyoutCalculation } from "./hooks/useBuyoutCalculation";
const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: theme.spacing(8),
        padding: theme.spacing(4),
        paddingBottom: theme.spacing(6)
    }
}));
export const Buyout = () => {
    const intl = useIntl();
    const classes = useStyles();
    const settings = useResource(BuyoutSettingsEndpoint, {});
    const { contract, isLoading: contractIsLoading, error: contractError, handleGetContract, reset: resetContract } = useBuyoutGetContract();
    const { calculation, error: calculationError, isLoading: calculationIsLoading, handleGetBuyoutCalculation, reset: resetCalculation } = useBuyoutCalculation();
    const handleGetContractWithReset = useCallback(async (registrationNumber) => {
        resetCalculation();
        await Promise.all([handleGetContract(registrationNumber)]);
    }, [handleGetContract, resetCalculation]);
    const handleResetForm = useCallback(() => {
        resetContract();
        resetCalculation();
    }, [resetContract, resetCalculation]);
    return (_jsx(Grid, { container: true, spacing: 3, className: classes.root, children: _jsx(Grid, { item: true, xs: 12, children: _jsxs(Grid, { container: true, spacing: 3, direction: "column", justifyContent: "space-between", children: [_jsx(Grid, { xs: 12, md: 8, item: true, children: _jsx(Typography, { variant: "h3", children: intl.formatMessage(messages.header) }) }), _jsx(Grid, { item: true, xs: 12, md: 8, lg: 6, children: _jsx(BuyoutForm, { settings: settings, onGetContract: handleGetContractWithReset, contract: contract, contractIsLoading: contractIsLoading, contractError: contractError, onGetBuyoutEvaluation: handleGetBuyoutCalculation, calculationIsLoading: calculationIsLoading, onResetForm: handleResetForm }) }), _jsx(Grid, { item: true, xs: 12, md: 8, lg: 6, children: _jsx(BuyoutCalculationResult, { calculation: calculation, calculationError: calculationError, calculationIsLoading: calculationIsLoading, contractIsLoading: contractIsLoading, settings: settings }) })] }) }) }));
};
//# sourceMappingURL=Buyout.js.map